import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MaterialCheckbox from '@material-ui/core/Checkbox';

class Checkbox extends Component {
  static propTypes = {
    defaultChecked: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.bool,
      PropTypes.string,
    ]),
    disabled: PropTypes.bool,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.bool,
      PropTypes.string,
    ])),
  };

  static defaultProps = {
    defaultChecked: '0',
    disabled: false,
    label: '',
    options: ['0', '1'],
  };

  state = { checked: this.props.defaultChecked };

  onCheck = () => {
    const { options } = this.props;
    const { checked } = this.state;

    this.setState({ checked: checked === options[0] ? options[1] : options[0] });
  }

  render() {
    const {
      disabled,
      label,
      name,
      options,
    } = this.props;
    const { checked } = this.state;

    return (
      <div>
        <input
          name={name}
          type="hidden"
          value={checked}
        />
        <FormControlLabel
          control={
            <MaterialCheckbox
              checked={checked === options[1]}
              disabled={disabled}
              onChange={this.onCheck}
            />
          }
          label={label}
        />
      </div>
    );
  }
}

export default Checkbox;
